export default {
  fps: state => state.fps,
  items: state => state.items,
  item: state => id => state.items.find(item => item.id === id),
  sort: state => state.sort,
  more: state => state.more,
  loading: state => state.loading,
  total: state => state.total,
  defaultSort: state => state.defaultSort,

  cluster: state => state.cluster,
  clusterId: state => state.cluster.id,
  clusterItems: state => state.cluster.items,
  clusterLoading: state => state.cluster.loading,
  clusterOutfits: state => state.cluster.outfits,
  clusterPage: state => state.cluster.page,

  logs: state => state.logs,
  logsId: state => state.logs.id,
  logsItems: state => state.logs.items,
  logsLoading: state => state.logs.loading,
};
